export default "__VITE_ASSET__Cd3IUNdg__"